import React, { useState, useRef, useEffect } from "react";
import WeeklyReportActiveIcon from "../../icons/weekly-report-icon-active.svg";
import WeeklyReportInactiveIcon from "../../icons/weekly-report-icon-inactive.svg";
import DownloadIcon from "../../../src/download-icon.svg";
import PDFIcon from "../../../src/pdficon.svg";
import CSVIcon from "../../../src/csvicon.svg";

const WeekTile = ({
  period,
  handleClick,
  index,
  title,
  subtitle,
  stats = {},
  isDisabled,
  isUpcoming = false,
  customStyles = {},
  upcomingLabel = "Upcoming",
  activeReportIcon = WeeklyReportActiveIcon,
  inactiveReportIcon = WeeklyReportInactiveIcon,
  isDisabledDownload,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [hoveredOption, setHoveredOption] = useState(null);
  const dropdownRef = useRef(null);

  const handleTileClick = (fileType) => {
    if (!isDisabled) {
      handleClick(period, fileType);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div style={{ position: "relative" }}>
      {isUpcoming && (
        <div style={{ position: "absolute", width: "100%", transform: "translate(-50%, -50%)", top: "50%", left: "50%", backgroundColor: "#CFD1D4", color: "#fff", padding: "4px", fontSize: "14px", fontWeight: "600", textAlign: "center", zIndex: 1, pointerEvents: "none" }}>
          {upcomingLabel}
        </div>
      )}

      <div
        className={`time-period-tile ${isDisabled || isUpcoming ? 'disabled' : ''}`}
        style={{ pointerEvents: isDisabled ? 'none' : 'auto', opacity: isDisabled ? 0.6 : 1, fontWeight: "400", padding: '12px', borderRadius: '8px', boxShadow: '0 2px 7px #E5E9EE', border: "1px solid #E5E9EE", backgroundColor: '#fff', display: 'flex', flexDirection: 'column', gap: '12px', ...customStyles }} >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'flex-start', }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', opacity: isUpcoming ? 0.5 : 1 }}>
            <div>
              <img src={isDisabled || isUpcoming ? inactiveReportIcon : activeReportIcon} height="50px" width="50px" alt="Period Report Icon" />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <div>
                {title && (<div style={{ fontWeight: 600, fontSize: "16px" }}>{title}</div>)}
              </div>
              {subtitle && <div style={{ fontSize: "14px" }}>{subtitle}</div>}
            </div>
          </div>
          <div ref={dropdownRef}
            style={{
              position: "relative", display: "inline-block", backgroundColor: isDisabled ? "#edf4ff" : "#EAF2FE", borderRadius: "50%", padding: "5px", boxSizing: "border-box",
              cursor: isDisabledDownload ? "not-allowed" : "pointer", opacity: isDisabledDownload ? 0.4 : 1,
            }}
            onClick={(e) => {
              if (isDisabledDownload) return
              e.stopPropagation();
              setIsDropdownOpen((prev) => !prev);
            }}
          >
            <img src={DownloadIcon} alt="Download" width="24px" height="24px" style={{ display: "block", margin: "0 auto" }} />
            {isDropdownOpen && (
              <div style={{ position: "absolute", right: 0, marginTop: "8px", backgroundColor: "#fff", border: "1px solid #ccc", borderRadius: "8px", boxShadow: "0 2px 6px rgba(0,0,0,0.15)", zIndex: 1000, width: "120px", }}>
                <div
                  onClick={() => handleTileClick("csv")}
                  onMouseEnter={() => setHoveredOption("csv")}
                  onMouseLeave={() => setHoveredOption(null)}
                  style={{ display: "flex", alignItems: "center", padding: "8px 12px", cursor: "pointer", gap: "8px", width: "100%", justifyContent: "space-between", backgroundColor: hoveredOption === "csv" ? "#F0F4FF" : "transparent", transition: "background-color 0.2s ease", borderTopLeftRadius: "8px", borderTopRightRadius: "8px", }} >
                  <span>CSV</span>
                  <img src={CSVIcon} alt="CSV" width="16px" height="16px" />
                </div>
                <hr
                  style={{ border: 'none', borderTop: '1px solid #D9D9D9', margin: "0", }} />
                <div
                  onClick={() => handleTileClick("pdf")}
                  onMouseEnter={() => setHoveredOption("pdf")}
                  onMouseLeave={() => setHoveredOption(null)}
                  style={{ display: "flex", alignItems: "center", padding: "8px 12px", cursor: "pointer", gap: "8px", width: "100%", justifyContent: "space-between", backgroundColor: hoveredOption === "pdf" ? "#F0F4FF" : "transparent", transition: "background-color 0.2s ease", borderBottomLeftRadius: "8px", borderBottomRightRadius: "8px", }} >
                  <span>PDF</span>
                  <img src={PDFIcon} alt="PDF" width="16px" height="16px" />
                </div>
              </div>
            )}
          </div>
        </div>
        <hr style={{ border: 'none', borderTop: '1px dotted #8E8F91', margin: '0' }} />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', rowGap: '8px', columnGap: '16px' }}>
          {Object.entries(stats).map(([key, stat]) => (
            <div key={key}>
              <div style={{ color: '#637381', fontSize: "14px" }}>{stat.label}</div>
              <div style={{ fontSize: "16px", fontWeight: "bold", color: isUpcoming ? '#B0B0B0' : '#212121' }}>{isUpcoming ? '-' : stat.value}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WeekTile;